import axios from 'axios';
import { getToken, getUser } from './general';
import { BASE_URL_AUTH } from '../constants';

export const getRequestWithNewToken = (originalRequest) => {
  const refreshToken = localStorage.getItem('refreshToken');
  return axios
    .post(`${BASE_URL_AUTH}/refresh`, {
      refreshToken,
    })
    .then((res) => {
      if (res.status === 200) {
        localStorage.setItem('token', res.data.idToken);
        return originalRequest ? instanceAxios(originalRequest) : null;
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

const instanceAxios = axios.create({});

instanceAxios.interceptors.request.use(
  (req) => {
    if (
      req.method === 'post' ||
      req.method === 'put' ||
      req.method === 'get' ||
      req.method === 'delete'
    ) {
      req.headers.Authorization = getToken();
      req.headers['Content-Type'] = 'application/json';
      req.headers.username = getUser();
    }
    return req;
  },
  (error) => {
    return Promise.reject(error);
  },
);

instanceAxios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      if (error.response && error.response.data && error.response.data.errorCode) {
        switch (error.response.data.errorCode) {
          case 'auth05':
            originalRequest._retry = true;
            console.log('[REFRESH TOKEN CALL]');
            return getRequestWithNewToken(originalRequest);
          default:
            break;
        }
      }
    }
    throw error;
  },
);
export const axiosInstance = instanceAxios;
export default instanceAxios;
